import React from "react";
import { CheckCircle2, Signal } from "lucide-react";

export const OperatorLogo = ({ op, className = "h-8", testid }) => {
  const muted = op && op.active === false ? "grayscale opacity-50" : "";
  return op?.logo
    ? <img src={op.logo} alt={op.name} className={`${className} ${muted} w-auto max-w-full object-contain transition-[filter,opacity]`} data-testid={testid} />
    : <span className={`${className} ${muted} inline-flex min-w-0 items-center gap-1 font-head font-semibold text-[11px] text-slate-900`} data-testid={testid}><Signal className="w-3.5 h-3.5 shrink-0 text-primary" /><span className="truncate">{op?.name}</span></span>;
};

export const OperatorMark = ({ op, size = "sm", testid }) => (
  <span className={`inline-flex shrink-0 items-center justify-center rounded-md border border-border bg-white ${size === "lg" ? "h-10 w-28 px-2" : "h-7 w-20 px-1.5"}`} data-testid={testid}>
    <OperatorLogo op={op} className={size === "lg" ? "max-h-7" : "max-h-5"} />
  </span>
);

const SIZES = {
  lg: { h: "h-24", w: "w-[calc(50%-0.4rem)] sm:w-56", logo: "h-14 w-40", pad: "px-5" },
  md: { h: "h-14", w: "w-40", logo: "h-10 w-32", pad: "px-4" },
  sm: { h: "h-11", w: "w-28", logo: "h-7 w-24", pad: "px-2" },
};

export const OperatorPicker = ({ ops, value, onChange, testid = "operator-picker", extra, size = "md", dimOthers = false, compact = false }) => {
  return <div className="flex flex-wrap items-center gap-2.5" role="radiogroup" data-testid={testid}>
    {ops.map((o) => {
      const on = value === o.key;
      const dim = (dimOthers || compact) && value && !on;
      const s = SIZES[compact ? "sm" : dimOthers && value ? (on ? "md" : "sm") : size];
      return <button key={o.key} type="button" role="radio" aria-checked={on} onClick={() => onChange(o.key)} title={o.active ? o.name : `${o.name} (non attivo)`}
        className={`relative flex ${extra ? "h-auto flex-col gap-1 py-2" : s.h} ${s.w} ${s.pad} items-center justify-center rounded-xl border bg-white transition-[width,height,border-color,box-shadow,transform,opacity,filter] duration-300 hover:-translate-y-0.5 ${on ? "border-primary ring-2 ring-primary/40 shadow-md" : "border-border hover:border-primary/50"} ${dim ? "opacity-50 grayscale hover:opacity-100 hover:grayscale-0" : ""}`}
        data-leave-guard={on ? undefined : ""} data-testid={`${testid}-${o.key}`}>
        <span className={`flex ${s.logo} items-center justify-center transition-[width,height] duration-300`}><OperatorLogo op={o} className="max-h-full" /></span>
        {extra && extra(o)}
        {on && (dimOthers || compact) && <CheckCircle2 className="absolute -top-2 -right-2 h-5 w-5 rounded-full bg-background text-primary" data-testid={`${testid}-${o.key}-selected`} />}
        {!o.active && <span className="sr-only" data-testid={`${testid}-${o.key}-inactive`}>non attivo</span>}
      </button>;
    })}
  </div>;
};
